// N/A for easy creatures!
export const uniqueTraits = [
  { armor: 1, defense: -1 },
  { armor: -1, defense: 1 },
  { attackSkill: 5, damageMod: -5 },
  { attackSkill: -5, damageMod: 5 },
  { wounds: 1, abilityNum: -1 },
  { CON: 2, WIL: -2 },
  { CON: -2, WIL: 2 },
  { STR: 2, DEX: -2 },
  { STR: -2, DEX: 2 },
  { wounds: 1, CON: -1, WIL: -1 },
];
